export enum AppCampaignEmployeeStatus {
    NotStarted = 0,
    InAction = 1,
    Finished = 2
}